/**
 * De baja: una no disponibilidad de la 004, con tres formas de decirlo.
 * La agenda no admite citas en el intervalo. «Hasta nuevo aviso» no tiene
 * fecha de fin en la calle; en la agenda se guarda un tope lejano.
 */
export const FIN_INDEFINIDO = '2099-12-31 23:59:59'

export type ModoBaja = 'hasta' | 'indefinida' | 'empieza'

export function esFinIndefinido(fin: string): boolean {
    return fin.startsWith('2099-12-31')
}

export function diaAnterior(iso: string): string {
    const [y, m, d] = iso.split('-').map(Number)
    const dt = new Date(Date.UTC(y!, (m ?? 1) - 1, d ?? 1))
    dt.setUTCDate(dt.getUTCDate() - 1)
    return dt.toISOString().slice(0, 10)
}

export function intervaloBaja(args: {
    hoy: string
    modo: ModoBaja
    fecha?: string
}): { inicio: string; fin: string } | { error: string } {
    const { hoy, modo, fecha } = args
    if (modo === 'indefinida') {
        return { inicio: `${hoy} 00:00:00`, fin: FIN_INDEFINIDO }
    }
    if (!fecha) return { error: 'falta la fecha' }
    if (fecha <= hoy) return { error: 'la fecha tiene que ser posterior a hoy' }
    if (modo === 'empieza') {
        return { inicio: `${hoy} 00:00:00`, fin: `${diaAnterior(fecha)} 23:59:59` }
    }
    return { inicio: `${hoy} 00:00:00`, fin: `${fecha} 23:59:59` }
}

export function cubreElDia(
    v: { profesionalId: number; inicio: string; fin: string },
    profesionalId: number,
    dia: string,
): boolean {
    if (v.profesionalId !== profesionalId) return false
    const ini = v.inicio.slice(0, 10)
    const fin = v.fin.slice(0, 10)
    return ini <= dia && dia <= fin
}

export function bajaDe<T extends { profesionalId: number; inicio: string; fin: string }>(
    vacaciones: readonly T[],
    profesionalId: number,
    hoy: string,
): T | null {
    return vacaciones.find((v) => cubreElDia(v, profesionalId, hoy)) ?? null
}

export function textoBaja(fin: string): string {
    if (esFinIndefinido(fin)) return 'hasta nuevo aviso'
    return `hasta el ${fin.slice(0, 10)}`
}

export function iniciales(nombre: string): string {
    const partes = nombre.trim().split(/\s+/).filter(Boolean)
    if (partes.length >= 2) return ((partes[0]?.[0] ?? '') + (partes[1]?.[0] ?? '')).toUpperCase()
    return nombre.trim().slice(0, 2).toUpperCase()
}
